/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
define(["require", "exports"], function (require, exports) {
    'use strict';
    function findAll(regex, string) {
        if (!regex.global) {
            throw new Error('not global regex');
        }
        var result = [];
        var match;
        while (match = regex.exec(string)) {
            result.push(match[0]);
        }
        return result;
    }
    exports.findAll = findAll;
});
//# sourceMappingURL=regex.js.map


// WEBPACK FOOTER //
// ./out/vs/base/common/regex.js